export default "__VITE_ASSET__DsJHhTl0__"